import React, { ErrorInfo, ReactNode } from 'react';

type ErrorBoundaryProps = {
  children: ReactNode;
};

type State = {
  error: Error | null;
  errorInfo: ErrorInfo | null;
};

abstract class BaseErrorBoundary extends React.Component {
  state: State = {
    error: null,
    errorInfo: null
  };

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Catch errors in any components below and re-render with error message
    // Sentry is already set up to capture any type errors or other unexpected exceptions

    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  componentDidUpdate(
    prevProps: Readonly<ErrorBoundaryProps>,
    prevState: Readonly<{}>,
    snapshot?: any
  ): void {
    if (prevProps.children !== this.props.children) {
      this.setState({ error: null, errorInfo: null });
    }
  }

  abstract render(): ReactNode;
}

export default BaseErrorBoundary;
